export default __webpack_public_path__ + "static/media/login-bg.a4fd6246.jpg";